<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card outlined>
          <v-card-title>
            {{ budget }}
            <v-spacer></v-spacer>
            <v-btn @click="product_dialog = true" color="primary">
              <v-icon left>mdi-barcode</v-icon> Carregar produto
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="form.product_feature.id">
      <v-col>
        <v-card outlined>
          <v-row no-gutters>
            <v-col cols="4">
              <v-img
                :src="form.product_feature.photo_url"
                height="300"
                contain
              ></v-img>
              <v-divider></v-divider>
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      <strong>
                        {{ form.product_feature.local_category_name }}
                      </strong>

                      {{ form.product_feature.brand_name }}
                      {{ form.product_feature.model }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.product_feature.barcode }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-list v-if="loading_buy === 100" dense>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-file</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ selected_budget || "Sem orçamentos" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-currency-usd</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ euro(total_budget) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col class="pa-5">
              <v-expansion-panels mandatory>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    SUBSTITUIÇÃO
                    <span v-if="total_buy && loading_buy == 100">
                      ({{ euro(total_buy) }})
                    </span>
                    <span v-else class="ml-1"> ({{ loading_buy }}%) </span>
                  </v-expansion-panel-header>

                  <v-divider></v-divider>
                  <v-expansion-panel-content v-if="loading_buy < 100">
                    <div class="pa-5 text-center">
                      <v-progress-circular
                        :rotate="360"
                        :size="100"
                        :width="15"
                        :value="loading_buy"
                        color="teal"
                      >
                        {{ loading_buy }}%
                      </v-progress-circular>
                    </div>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content v-else>
                    <div
                      v-for="(marketplace, index) in marketplaces"
                      :key="marketplace.name"
                    >
                      <v-divider v-if="index > 0" inset></v-divider>
                      <v-list-item>
                        <v-list-item-avatar tile size="60">
                          <v-img :src="marketplace.logo_url" contain></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            {{ marketplace.name }}
                          </v-list-item-subtitle>
                          <v-list-item-total>
                            {{ euro(marketplace.total) }}
                            <v-chip
                              x-small
                              color="green"
                              dark
                              label
                              class="ml-2"
                              outlined
                            >
                              Em stock
                            </v-chip>
                          </v-list-item-total>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-radio-group
                            :value="marketplace.name === selected_marketplace"
                          >
                            <v-radio
                              @click.prevent="
                                selected_marketplace = marketplace.name
                              "
                              :value="true"
                            ></v-radio>
                          </v-radio-group>
                        </v-list-item-action>
                      </v-list-item>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    REPARAÇÃO
                    <span v-if="total_repair"> ({{ euro(total_repair) }})</span>
                  </v-expansion-panel-header>

                  <v-divider></v-divider>

                  <v-expansion-panel-content>
                    <v-alert v-if="perc_repair >= 80" type="warning" class="mt-2" text outlined>
                      A reparação atingiu {{ perc_repair }}% do orçamento de substituição
                    </v-alert>
                    <div v-for="(part, index) in parts" :key="part.name">
                      <v-divider v-if="index > 0" inset></v-divider>
                      <v-list-item>
                        <v-list-item-avatar tile size="60">
                          <v-img :src="part.image" contain></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            {{ part.name }}
                          </v-list-item-subtitle>
                          <v-list-item-total>
                            {{ euro(part.total) }}
                          </v-list-item-total>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-text-field
                            v-model="part.qty"
                            type="number"
                            number
                            dense
                            outlined
                            single-line
                            hide-details
                            style="width: 70px"
                            min="0"
                          >
                            <template v-slot:prefix> UN </template>
                          </v-text-field>
                        </v-list-item-action>
                      </v-list-item>
                    </div>
                    <v-divider inset></v-divider>
                    <v-list-item link>
                        <v-list-item-avatar color="grey lighten-3" tile size="60">
                          <v-icon>mdi-help</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="primary--text">
                            Adicionar outra peça
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title> Serviço </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <MoneyInputVue
                          v-model="total_service"
                          reverse
                          hide-details
                          outlined
                          dense
                          style="width: 150px"
                        />
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title> Total </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        {{ euro(total_repair) }}
                      </v-list-item-action>
                    </v-list-item>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!-- <v-col cols="4">
        <v-card>
          
        </v-card>
      </v-col> -->
    </v-row>
    <v-dialog
      v-model="product_dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <ProductForm
        :product="form.product_feature"
        :product_dialog="product_dialog"
        @submit="setProduct"
        @cancel="product_dialog = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import ProductForm from "@/components/Lead/ProductForm";
import money from "../../tools/money";
import MoneyInputVue from "../../components/MoneyInput.vue";

export default {
  components: { ProductForm, MoneyInputVue },

  props: {
    budget: [String, Number],
  },

  data() {
    return {
      loading_buy: 0,
      loading_repair: true,
      euro: money.euro,
      form: {
        damage_type: {},
        room_feature: {
          room_type: null,
        },
        product_feature: {
          local_category_id: null,
          local_category_name: "",
          brand_id: null,
          brand_name: "",
        },
        damage: null,
        classification: null,
        needs_research: false,
      },
      product_dialog: false,

      marketplaces: [
        {
          name: "Worten",
          url: "https://www.worten.pt/outlet/grandes-eletrodomesticos/maquinas-de-loica/maquina-de-lavar-loica-beko-dfn05321x-outlet-grade-a-13-conjuntos-59-8-cm-inox-7501643",
          total: 255.97,
          logo_url:
            "http://3.bp.blogspot.com/-FlaWi3BiCqs/TmfGvj39ePI/AAAAAAAAAKQ/d28kcgDlALo/s1600/worten_logo_g_1219761742.jpg",
        },
        {
          name: "Hipermercado.pt",
          total: 265.56,
          logo_url: "https://s1.kuantokusta.pt/img_upload/logins/11262_1.png",
        },
        {
          name: "Clubtek",
          total: 325.29,
          logo_url: "https://s1.kuantokusta.pt/img_upload/logins/10178_1.png",
        },
        {
          name: "Digibest",
          total: 332.0,
          logo_url: "https://s1.kuantokusta.pt/img_upload/logins/12043_1.png",
        },
      ],

      parts: [
        {
          name: "Mecanismo a02437701",
          total: 25,
          image:
            "https://samatec.vteximg.com.br/arquivos/ids/174728-230-230/IMG_4123.jpg?v=637250787349070000",
          selected: false,
          qty: 0,
        },
        {
          name: "Rolamento",
          total: 0.67,
          image:
            "https://samatec.vteximg.com.br/arquivos/ids/166842-230-230/Kit-50-Rolamento-6006-2Rs-Chavetado-Lavadora-Electrolux---Black-Friday.png?v=636470482468100000",
          selected: false,
          qty: 0,
        },
        {
          name: "Mecanismo a99016901 original",
          total: 15.69,
          image:
            "https://samatec.vteximg.com.br/arquivos/ids/176601-230-230/A99016901.jpg?v=637412421908300000",
          selected: false,
          qty: 0,
        },
        {
          name: "Timer",
          total: 100,
          image:
            "https://samatec.vteximg.com.br/arquivos/ids/165775-230-230/64590681.jpg?v=636439421174100000",
          selected: false,
          qty: 0,
        },
      ],
      total_service: 0,
      selected_marketplace: "Worten",
      interval: {},
    };
  },
  methods: {
    setProduct(product) {
      this.form.product_feature = product;

      if (product) {
        this.interval = setInterval(() => {
          if (this.loading_buy === 100) {
            clearInterval(this.interval);
            return;
          }
          this.loading_buy += 25;
        }, 700);
      }
    },
  },
  computed: {
    total_repair() {
      const parts = this.parts;

      let total = 0;
      parts.forEach((part) => {
        total += part.qty * part.total;
      });

      total += Number.parseFloat(this.total_service);

      return total;
    },

    total_buy() {
      const marketplace = this.marketplaces.find(
        (m) => m.name === this.selected_marketplace
      );
      if (!marketplace) return null;

      return marketplace.total;
    },

    selected_budget() {
      if (!this.total_repair && !this.total_buy) {
        return null;
      }

      if (!this.total_buy) return "Reparação";

      if (!this.total_repair) return "Substituição";

      if (this.perc_repair <= 80) {
        return "Reparação";
      }

      return "Substituição";
    },

    total_budget() {
      return this.selected_budget === "Reparação"
        ? this.total_repair
        : this.total_buy;
    },

    perc_repair() {
      return Math.round(100/this.total_buy * this.total_repair);
    }
  },
};
</script>
